/**
 * 컴포넌트 마운트 시 자동 포커스를 설정하는 Hook입니다.
 *
 * @example
 * ```tsx
 * const MyComponent = () => {
 *   const inputRef = useAutoFocus();
 *   return <input ref={inputRef} />;
 * };
 * ```
 */
import { useRef, useEffect, type MutableRefObject } from 'react';

/**
 * 컴포넌트 마운트 시 ref가 가리키는 요소에 자동으로 포커스를 설정합니다.
 * @returns 포커스를 설정할 요소에 연결할 ref 객체
 */
function useAutoFocus<T extends { focus: () => void }>(): MutableRefObject<T | null> {
  const inputRef = useRef<T | null>(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  return inputRef;
}

export default useAutoFocus;
